import { Component, OnInit, Input, Output,
         EventEmitter, ViewChild } from '@angular/core';

import { DBService } from '../../db.service';
import { CloudStorageService } from '../../cloud-storage.service';
import { slide } from '../../animations';

@Component({
  selector: 'member-form-modal',
  templateUrl: './member-form-modal.component.html',
  styleUrls: ['./member-form-modal.component.scss'],
  animations: [
    slide
  ]
})
export class MemberFormModalComponent implements OnInit {
  @ViewChild('previewImg') previewImg;

  @Input()  selectedMember: any;
  @Output() onHideFormModal = new EventEmitter<boolean>();

  member = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    country: "",
    companyName: "",
    companyAddress: "",
    companyCity: "",
    companyState: "",
    companyAbout: "",
    userLevel: 1,
    zip: ""
  }

  activeTab = 0; // 0 - User Profile, 1 - Company Profile, 2 - Gallery
  uploadedFile: File;

  constructor(
    private dbService: DBService,
    private csService: CloudStorageService
  ) { }

  ngOnInit() {
    if (this.selectedMember) {
      this.member = this.selectedMember;
    }
  }

  onHideModal() {
    this.onHideFormModal.emit(true);
  }

  submitForm() {
    // Ensure field is a number
    // this.member.userLevel = parseInt(this.member.userLevel);

    if (this.selectedMember && this.selectedMember.$key) {
      this.dbService.updateMember(this.selectedMember.$key,
                                  this.member,
                                  this.uploadedFile);
    } else {
      this.dbService.addMember(this.member, this.uploadedFile);
    }
    this.onHideModal();
  }

  onFileChange(event) {
    let file = event.target.files[0];
    let reader = new FileReader();

    reader.addEventListener("load", () => {
      this.previewImg.nativeElement.src = reader.result;
    });

    reader.readAsDataURL(file);
    this.uploadedFile = file;

  }

  activateTab(tab) {
    this.activeTab = tab;
  }


}



// WEBPACK FOOTER //
// ./src/app/members/member-form-modal/member-form-modal.component.ts